/**
 * LogoImage Component
 * 
 * Logo component that uses PNG image assets instead of SVG.
 * Useful for cases where the full rendered logo image is needed.
 * Uses brand configuration for assets and domain name.
 * 
 * Usage:
 *   import { LogoImage } from '../design-system/brand';
 *   <LogoImage size="20px" variant="noBackground" />
 */
import React from "react";
import { brand } from "./brandConfig";

const LogoImage = ({ 
  size = "20px", 
  className = "drop-shadow-lg",
  variant = "noBackground" 
}) => {
  // Map variant to asset path
  const logoPath = brand.assets.logos[variant] || brand.assets.logos.noBackground;
  
  return (
    <img
      src={process.env.PUBLIC_URL + logoPath}
      alt={`${brand.identity.domain} logo`}
      style={{ height: size }}
      className={className}
    />
  );
};

export default LogoImage;
